// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"79e82e92c656cad7","161":"fb76628797c8acf5","356":"71518a59d9a35ffa","379":"c48d7aae6e4014aa","484":"6132d07eb09f83a3","538":"d288b978e330e581","539":"4f9af2438633b758","604":"3abec64d6d0f088c","729":"1f35c3f338aa1012","886":"f5c48b5b485e0920"}[chunkId] + ".js";
};